// The microgaming module is only available within their iframe
define('gameInterfaces/pages/MicrogamingGameInterface',['bluebird', 'microgaming'], function(Promise, mgs) {

    function MicrogamingGameInterface(RealityCheckViewModel) {

        var self = this;

        self.realityCheckViewModel = new RealityCheckViewModel(self);

        self.canActivate = function() {

            return Promise.all([
                self.realityCheckViewModel.canActivate(),
                new Promise(function(resolve) {
                    mgs.inGameInterface.init(resolve);
                })
            ]).then(function() {
                return true;
            });

        };

        self.compositionComplete = function() {

            self.realityCheckViewModel.realityCheck.subscribe(function() {

                mgs.inGameInterface.preventGameplay();
                mgs.inGameInterface.setMode('fullscreen');

            });
        };

        self.continuePlaying = function() {
            mgs.inGameInterface.allowGameplay();
            mgs.inGameInterface.setMode('hidden');
        };

        self.exitToLobby = function() {
            mgs.inGameInterface.toLobby();
        };

        self.exitToGameRoundHistory = function() {
            mgs.inGameInterface.toBanking();
        };

    }

    return MicrogamingGameInterface;

});

